package com.eladfinish.bible.contest.screens.openQuestions.ui.dialogs

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.choose_questions_topic
import com.eladfinish.bible.contest.ui.components.dialogs.AlternateRowColorsDialog
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import com.eladfinish.bible.contest.ui.models.AlternateRowData
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

@Composable
internal fun OpenQuestionsTableOfContents(
    items: ImmutableList<AlternateRowData>,
    onDismiss: () -> Unit,
    onItemClicked: (Int) -> Unit,
) {
    BasicDialogWithTitle(
        onDismiss = onDismiss,
        title = stringResource(SharedRes.strings.choose_questions_topic),
        content = {
            AlternateRowColorsDialog(
                items = items.toImmutableList(),
                itemAsString = { it.title },
                onItemClick = { index, _ ->
                    onItemClicked(index)
                },
            )
        }
    )
}
